var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgChevronRight = function SvgChevronRight(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 14,
    viewBox: "0 0 8 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.48206 6.98708L0.318462 12.1921C0.218831 12.2891 0.139361 12.4052 0.0846907 12.5334C0.0300203 12.6617 0.00124313 12.7997 3.95234e-05 12.9393C-0.00116408 13.079 0.0252297 13.2174 0.0776802 13.3467C0.130131 13.4759 0.207588 13.5933 0.305532 13.692C0.403476 13.7907 0.519946 13.8688 0.648146 13.9217C0.776345 13.9746 0.913707 14.0012 1.05222 14C1.19072 13.9987 1.32761 13.9697 1.45487 13.9146C1.58214 13.8595 1.69725 13.7794 1.79348 13.679L7.69458 7.73051C7.89014 7.53332 8 7.26591 8 6.98708C8 6.70825 7.89014 6.44084 7.69458 6.24365L1.79348 0.295175C1.59674 0.103632 1.33323 -0.00235606 1.05972 3.97504e-05C0.786213 0.00243556 0.524578 0.113023 0.331169 0.307985C0.137761 0.502946 0.0280534 0.766681 0.0256767 1.04239C0.0232999 1.31809 0.128444 1.58371 0.318462 1.78203L5.48206 6.98708Z",
    fill: "currentColor"
  })));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgChevronRight);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/chevron-right.ee38b69009bb3d676c31944fd31791aa.svg";